import { Injectable, Signal, computed, inject } from '@angular/core';
import { AdminRole } from '../enums';
import { CurrentUserService } from './current-user.service';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
  private readonly currentUserService = inject(CurrentUserService);
  private readonly currentUser = this.currentUserService.currentUser;

  readonly isSuperAdmin = this.hasRole(AdminRole.SuperAdmin);

  hasRole(role: AdminRole): Signal<boolean> {
    return computed(() => this.rolesOfCurrentUser().includes(role));
  }

  hasAnyRole(roles: AdminRole[]): Signal<boolean> {
    return computed(() => {
      const current = this.rolesOfCurrentUser();
      return roles.some((role) => current.includes(role));
    });
  }

  private rolesOfCurrentUser(): string[] {
    return this.currentUser()?.roles ?? [];
  }
}
